"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _index = require("./index");
/**
 * Show a notification
 */
function showNotification(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    var _options$timeout = options.timeout,
      timeout = _options$timeout === void 0 ? 2000 : _options$timeout,
      _options$type = options.type,
      type = _options$type === void 0 ? 'success' : _options$type,
      _options$indefinite = options.indefinite,
      indefinite = _options$indefinite === void 0 ? false : _options$indefinite,
      _options$linkMessage = options.linkMessage,
      linkMessage = _options$linkMessage === void 0 ? '' : _options$linkMessage,
      _options$onClick = options.onClick,
      onClick = _options$onClick === void 0 ? null : _options$onClick;
    var action = {
      type: _types.SHOW_NOTIFICATION,
      payload: {
        show: true,
        message: message,
        type: type,
        linkMessage: linkMessage,
        onClick: onClick
      }
    };
    dispatch(action);
    if (!indefinite) {
      setTimeout(function () {
        dispatch((0, _index.clearNotification)());
      }, timeout);
    }
  };
}
var _default = exports["default"] = showNotification;